module.exports = __webpack_public_path__ + "static/img/brees-2007-top.c20139f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-top.jpg
// module id = 9Eet
// module chunks = 1